import { all, put, takeLatest, call } from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import crud from 'react/api/actions/crud';
import sku from 'react/api/actions/sku';
import { validIfServerVersionIsBiggerThan } from 'react/utils/utils';

function* clearImagePreviewAfterSaveForm({ payload: { entity } }) {
  if (validIfServerVersionIsBiggerThan(6.49) && entity === 'Sku') {
    yield put(sku.actionCreators.resetImagePreview());
  }
}

function* setImagePreviewFromInitialValues({ payload: { entity, values } }) {
  if (
    entity === 'Sku' &&
    validIfServerVersionIsBiggerThan(6.49) &&
    values?.length
  ) {
    const imageURL = values[0].skuImageUrl;
    if (!imageURL) return;
    yield put(
      sku.actionCreators.updateImagePreviewComponent({
        imageURL,
        showLoading: true
      })
    );
  }
}

function* requestValidateSkuImageUrl({ payload: { imageUrl } }) {
  const URL = `/Sku/validateImageUpload?url=${encodeURI(imageUrl)}`;
  const response = yield call(defaultFetch, URL, null, 'GET', false);
  const { error } = response;
  let payload = {};
  if (error?.status === 504) {
    payload = {
      errorMessage: Monet.I18n.getResourcesByKey('sku.imageURLPreview.timeout'),
      hasError: true,
      showLoading: false
    };
  } else if (error?.status === 400) {
    payload = {
      errorMessage: Monet.I18n.getResourcesByKey(
        'sku.imageURLPreview.badRequest'
      ),
      hasError: true,
      showLoading: false
    };
  } else if (error?.errorMessages) {
    payload = {
      errorMessage: Monet.Form.Messages.getErrorMessageToBeDisplayed(
        response.error.errorMessages
      ),
      hasError: true,
      showLoading: false
    };
  } else {
    payload = {
      imageURL: imageUrl
    };
  }
  yield put(sku.actionCreators.updateImagePreviewComponent(payload));
}

function* watchRequestValidateSkuImageUrl() {
  yield takeLatest(
    sku.actions.requestValidateSkuImageUrl,
    requestValidateSkuImageUrl
  );
}

function* watchClearFormState() {
  yield takeLatest(crud.actions.clearFormState, clearImagePreviewAfterSaveForm);
}

function* watchFetchInitialFormValues() {
  yield takeLatest(
    crud.actions.fetchInitialFormValuesSuccess,
    setImagePreviewFromInitialValues
  );
}

export default function* () {
  yield all([
    watchClearFormState(),
    watchFetchInitialFormValues(),
    watchRequestValidateSkuImageUrl()
  ]);
}
